module.exports = __webpack_public_path__ + "static/media/brick-wall.4684941f.svg";